/// <amd-module name="VSSUI/Components/VssPersona/VssPersona.Initials" />
import { IColor } from "VSSUI/Utilities/Color";

const PERSONA_COLOR_BLUE: IColor = { red: 37, green: 116, blue: 204 };
/**
 * Colors added here should be checked via running FastPass before commiting.
 *
 * @see https://accessibilityinsights.io/
 */
const PERSONA_COLOR_PALETTE: IColor[] = [
    { red: 104, green: 123, blue: 33 }, // Light Green
    { red: 76, green: 119, blue: 168 }, // Light Blue
    { red: 177, green: 87, blue: 144 }, // Light Pink
    { red: 0, green: 133, blue: 0 }, // Green
    { red: 30, green: 113, blue: 69 }, // Dark Green
    { red: 217, green: 0, blue: 128 }, // Pink
    { red: 126, green: 56, blue: 120 }, // Magenta
    { red: 96, green: 60, blue: 186 }, // Purple
    { red: 98, green: 113, blue: 171 }, // Lavender
    { red: 0, green: 130, blue: 129 }, // Teal
    PERSONA_COLOR_BLUE,
    { red: 43, green: 87, blue: 151 }, // Dark Blue
    { red: 196, green: 74, blue: 38 }, // Orange
    { red: 185, green: 29, blue: 71 } // Dark Red
];

// Char.IsLetter ranges
const LETTERS: string[] = [
    "[\u0030-\u0039]", // NUMBER 0 - NUMBER 9 (eg. 1Es)
    "[\u0041-\u005A]", // LATIN CAPITAL LETTER A - LATIN CAPITAL LETTER Z
    "[\u0400-\u042F]", // CYRILLIC CAPITAL LETTER IE WITH GRAVE - CYRILLIC CAPITAL LETTER YA
    "[\u0061-\u007A]", // LATIN SMALL LETTER A - LATIN SMALL LETTER Z
    "[\u03AC-\u03CE]", // GREEK SMALL LETTER ALPHA WITH TONOS - GREEK SMALL LETTER OMEGA WITH TONOS
    "[\u01C5]", // LATIN CAPITAL LETTER D WITH SMALL LETTER Z WITH CARON
    "[\u1FFC]", // GREEK CAPITAL LETTER OMEGA WITH PROSGEGRAMMENI
    "[\u02B0-\u02C1]", // MODIFIER LETTER SMALL H - MODIFIER LETTER REVERSED GLOTTAL STOP
    "[\u1D2C-\u1D61]", // MODIFIER LETTER CAPITAL A - MODIFIER LETTER SMALL CHI
    "[\u05D0-\u05EA]", // HEBREW LETTER ALEF - HEBREW LETTER TAV
    "[\u0621-\u063A]", // ARABIC LETTER HAMZA - ARABIC LETTER GHAIN
    "[\u4E00-\u9FC3]", // <CJK Ideograph, First> - <CJK Ideograph, Last>
    "[\u00C0-\u00FF]", // LATIN-1 SUPPLEMENT
    "[\u0100-\u017F]", // LATIN-1 EXTENDED-A
    "[\u0180-\u024F]" // LATIN-1 EXTENDED-B
];

const LETTERS_REGEX = LETTERS.join("|");

export function getInitialsColorFromName(displayName: string | undefined): IColor {
    if (!displayName) {
        return PERSONA_COLOR_BLUE;
    }

    let hashCode: number = 0;
    for (let i: number = displayName.length - 1; i >= 0; i--) {
        const ch: number = displayName.charCodeAt(i);
        const shift: number = i % 8;
        // tslint:disable-next-line:no-bitwise
        hashCode ^= (ch << shift) + (ch >> (8 - shift));
    }

    return PERSONA_COLOR_PALETTE[hashCode % PERSONA_COLOR_PALETTE.length];
}

export function getInitialsFromName(displayName: string | undefined): string {
    if (!displayName) {
        return "";
    }

    const segments: string[] = displayName.split(" ").filter(x => x !== "");
    if (segments.length === 0) {
        return "";
    }

    let firstNameInitial = "";
    let lastNameInitial = "";

    segments.forEach(segment => {
        if (segment[0].match(LETTERS_REGEX)) {
            if (firstNameInitial.length === 0) {
                firstNameInitial = segment[0];
            } else {
                lastNameInitial = segment[0];
            }
        }
    });

    return firstNameInitial.concat(lastNameInitial).toUpperCase();
}
